<template>
    <div>
        <div class="directory">
            <Breadcrumb />
            <Search :title="'Verzeichnis A-Z'" :keyword="currentSearchKeyword" :selectedCategory="currentSearchCategory"
                :selectedTag="currentSearchTag" @reload="reload" />

            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mt30">
                        <div class="row directory--element" v-for="item in alphabeticalInstitutionList"
                            :key="item.letter">
                            <div class="col-12">
                                <h2 class="title">{{ item.letter }}</h2>
                                <div class="bar"></div>
                            </div>

                            <div class="col-lg-4 col-md-6 directory--element__single"
                                v-for="institution in item.institutions" :key="institution.id"
                                :id="'institution-' + institution.id" :data-institution-id="institution.id"
                                @click.capture="rememberLastVisited(institution.id)">
                                <CardInstitution :content="institution" :isSmall="false" :marginBottom="'0px'"
                                    :marginRight="'0px'" v-if="institution != null"
                                    @click.native="rememberLastVisited(institution.id)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-margin">
        </div>

    </div>
</template>

<script>
import Search from '@/components/Search.vue';
import Breadcrumb from '@/components/controls/Breadcrumb.vue';
import CardInstitution from '@/components/cards/CardInstitution.vue';

import { search } from '@/api/content';
import { showLoader, hideLoader, sortByProperty, buildFilterSignatureFromQuery, saveLastVisitedItem, loadLastVisitedItem } from '@/utils/helpers';

export default {
    name: 'Verzeichnis',
    components: {
        Breadcrumb,
        Search,
        CardInstitution
    },
    data() {
        return {
            loader: null,
            searchState: {
                keyword: '',
                selectedCategory: null,
                selectedTag: null
            },
            institutionDataSet: {
                total: 0,
                data: null,
                meta: null,
                query: {
                    page: 1,
                    limit: 1000,
                    type: 'view',
                    view_status: 1,
                    selectedAppId: this.$appId,
                    selectedContentTypeId: this.$institutionId,
                    keyword: [],
                    sort: {
                        prop: 'title',
                        order: 'ascending'
                    },
                },
            },
        }
    },
    computed: {
        institutions() {
            if (this.institutionDataSet.data != null && this.institutionDataSet.data.length > 0) {
                /*hard-coded Langcode*/
                return sortByProperty(this.institutionDataSet.data, 'title', 'de');
            }
            return null;
        },
        alphabeticalInstitutionList() {
            if (this.institutions != null) {

                /*we need to order the institutions into an array of objects by the first letter*/
                /*init*/
                var resultSet = [];
                var singleResultSet = {};
                var letter = null;

                for (var i = 0; i < this.institutions.length; i++) {
                    var institution = this.institutions[i];
                    /*let's check if the current letter is the same as the first letter from the title of the institution*/
                    if (institution.title.substring(0, 1).toUpperCase() != letter) {
                        /*check if the current letter is null. If that is not the case, we'll push the singleResultSet onto the resultSet*/
                        if (letter != null) {
                            resultSet.push(singleResultSet);
                        }

                        /*set the letter for the comparison*/
                        letter = institution.title.substring(0, 1).toUpperCase();

                        singleResultSet = {
                            letter: institution.title.substring(0, 1).toUpperCase(),
                            institutions: [],
                        };
                    }

                    /*add the current institution to the singleResultSet*/
                    singleResultSet.institutions.push(institution);

                }
                /*at the end of the for-loop there is still one last singleResultSet that is not part of the overall result set.*/
                resultSet.push(singleResultSet);
                return resultSet;
            }
            return null;

        },
        currentSearchKeyword() {
            return this.searchState.keyword;
        },
        currentSearchCategory() {
            return this.searchState.selectedCategory;
        },
        currentSearchTag() {
            return this.searchState.selectedTag;
        },
        categories() {
            return this.$store.getters.getCategories || [];
        },
        tags() {
            return this.$store.getters.getTags || [];
        }
    },
    created() {
        this.initializeFromUrl();
    },
    methods: {
        showLoader,
        hideLoader,
        sortByProperty,
        async getInstitutionList() {
            this.loader = this.showLoader(this.loader);
            const { limit, page } = this.institutionDataSet.query;
            const { data, meta } = await search(this.institutionDataSet.query);
            this.institutionDataSet.data = data;
            data.forEach((element, index) => {
                element['index'] = (page - 1) * limit + index + 1;
            });

            this.institutionDataSet.meta = meta;
            this.institutionDataSet.total = meta.total;
            this.loader = this.hideLoader(this.loader);

            // Try to scroll to the last visited institution after data load
            this.$nextTick(() => {
                try {
                    const signature = this.getCurrentFilterSignature();
                    const lastId = loadLastVisitedItem(this.$route.path, signature);
                    if (lastId && typeof lastId === 'number') {
                        let attempts = 0;
                        const tryScroll = () => {
                            attempts++;
                            const elem = document.getElementById(`institution-${lastId}`) || document.querySelector(`[data-institution-id="${lastId}"]`);
                            if (elem) {
                                elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            } else if (attempts < 10) {
                                setTimeout(tryScroll, 100);
                            }
                        };
                        tryScroll();
                    }
                } catch (e) { /* no-op */ }
            });
        },
        updateUrl() {
            // Create URL parameters with separate fields
            const queryParams = { ...this.$route.query };

            queryParams.keyword = this.searchState.keyword || undefined;
            queryParams.category = this.searchState.selectedCategory || undefined;
            queryParams.tag = this.searchState.selectedTag || undefined;

            // Remove the old 'q' parameter if it exists
            delete queryParams.q;

            this.$router.replace({ query: queryParams });
        },
        initializeFromUrl() {
            const query = this.$route.query;

            // Initialize search state from separate URL parameters
            this.searchState = {
                keyword: query.keyword ? decodeURIComponent(query.keyword) : '',
                selectedCategory: query.category ? decodeURIComponent(query.category) : null,
                selectedTag: query.tag ? decodeURIComponent(query.tag) : null
            };

            // Handle legacy 'q' parameter if it exists (for backward compatibility)
            if (query.q && !query.keyword && !query.category && !query.tag) {
                this.searchState.keyword = decodeURIComponent(query.q);
            }

            // Update the query format for the API
            this.updateApiQuery();

            // Fetch data with URL parameters
            this.getInstitutionList();
        },
        updateApiQuery() {
            // Convert search state to the format expected by the API
            this.institutionDataSet.query.keyword = [];

            if (this.searchState.keyword) {
                this.institutionDataSet.query.keyword.push(this.searchState.keyword);
            }
            if (this.searchState.selectedCategory) {
                this.institutionDataSet.query.keyword.push(this.searchState.selectedCategory);
            }
            if (this.searchState.selectedTag) {
                this.institutionDataSet.query.keyword.push(this.searchState.selectedTag);
            }
        },
        reload(query) {
            // Update search state from Search component
            this.searchState = {
                keyword: query.selectedKeyword || '',
                selectedCategory: query.selectedCategory || null,
                selectedTag: query.selectedTag || null
            };

            // Update API query format
            this.updateApiQuery();

            // Update URL with new search terms
            this.updateUrl();

            this.getInstitutionList();
        },
        getCurrentFilterSignature() {
            const query = this.$route.query;
            const qp = {};
            if (query.keyword) qp.keyword = query.keyword;
            if (query.category) qp.category = query.category;
            if (query.tag) qp.tag = query.tag;
            return buildFilterSignatureFromQuery(qp);
        },
        rememberLastVisited(id) {
            try {
                const signature = this.getCurrentFilterSignature();
                saveLastVisitedItem(this.$route.path, signature, id);
            } catch (e) { /* no-op */ }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.directory {
    position: relative;
    background: #fff;

    .container {

        @media (max-width: 991px) {
            max-width: 100%;
            padding: 0px 40px;
        }

        @media (max-width: 490px) {
            max-width: 100%;
            padding: 0px 20px;
        }

    }

    &--element {
        .title {
            font-size: 24px;
            background: #fff;
            display: inline-block;
            padding-right: 20px;
        }

        .bar {
            height: 3px;
            width: calc(100% - 50px);
            background-color: #E30059;
            display: inline-block;
            margin-bottom: 7px;
        }

        &__single {
            margin-top: 30px;

            @media (max-width: 490px) {
                margin-top: 15px;
            }

        }

        margin-bottom: 30px;
    }

    &.footer-margin {
        @media (max-width: 786px) {
            margin-bottom: 0 !important;
        }
    }
}
</style>
